import React from "react";
import { WavingRepublicFlag } from "./RepublicCelebration";
import "./remembrance.css";

export function RemembranceBackdrop() {
  return <div className="remembrance-backdrop" aria-hidden="true">
    <div className="remembrance-portrait" />
    <WavingRepublicFlag />
    <div className="remembrance-rule" />
  </div>;
}

export function RemembranceTribute({ phase }) {
  const moment = phase === "silence";
  return <section className="remembrance-tribute" aria-label="10 Kasım Atatürk'ü anma">
    <p className="remembrance-date">10 KASIM · 1881 — 1938</p>
    <h2>Özlemle.<br />Saygıyla.</h2>
    <p className="remembrance-name">Gazi Mustafa Kemal Atatürk</p>
    <div className="remembrance-time" aria-hidden="true">09<span>.</span>05</div>
    <p className="remembrance-message" role="status" aria-live="polite">
      {moment ? "Bir dakikalık saygı anı." : phase === "before" ? "Saat 09.05’te, saygıyla…" : "Hatıran ve emanetin daima bizimle."}
    </p>
    <div className="remembrance-divider" aria-hidden="true" />
  </section>;
}
